<template>
  <div class="dialogTip" v-show="visible">
    <div class="bg-content"></div>
    <div class="main-content">
      <div class="main-header">提示</div>
      <div class="main-body">
        请先在答题区定位光标位置
      </div>
      <div class="main-footer">
        <button @click="closeDialog">确认</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DialogMatrix',
  props: {
    visible: { type: Boolean, default: false }
  },
  methods: {
    closeDialog() {
      this.hide();
    },
    hide() {
      $('.dialogTip').hide()
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.dialogTip {
  .bg-content{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,.4);
    z-index: 999;
  }
  .main-content {
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    margin-left: -300px;
    margin-top: -150px;
    padding: 30px 20px 40px;
    width: 600px;
    height: 300px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    z-index: 1001;
    border: 1px solid #888;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    color: #666;
    border-radius: 5px;
    .main-header{
      font-size: 18px;
      color: #447dff;
      border-bottom: 1px solid #447dff;
      margin: 10px 0;
    }
    .main-body{
      .text-warning {
        color: #ffc107;
      }
    }
    .main-footer{
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
      button{
        min-width: 85px;
        border-radius: 4px;
        background: #447dff;
        color: #fff;
        border: 1px solid #447dff;
        padding: 5px;
        &.btn-cancel{
          background: #8c93ac;
          border: 1px solid #8c93ac;
          margin-left:24px;
        }
      }
    }
  }
}
</style>

